import { connect } from 'react-redux'
import { withMe } from 'pobble-components/dist/pobble-user'
import Navigation from './navigation'

const mapStateToProps = (state, { me, meRequest }) => ({
  pending: meRequest.pending,
  canSeeMembershipTab:
    !meRequest.pending && me && me.account.policy.can_see_subscriptions,
  canSeeSchoolTab:
    !meRequest.pending && me && me.account.policy.view_school_tab,
  canSeeMaterialTab:
    !meRequest.pending && me && me.account.policy.can_see_material_page
})

export default withMe(
  connect(
    mapStateToProps,
    null
  )(Navigation)
)
